import { API, Storage, Auth } from 'aws-amplify';

/**
 * s3内の各オブジェクトを取得するための署名URLを作成する
 */
export const fetchS3Object = async(filepath) => {
  const s3_object = await Storage.get(filepath, {
    level: 'public',
    customPrefix: { public: '' }
  });
  return s3_object
}

/**
 * APIを実行するためのトークンを返す処理
 */
export const getAuthToken = async() => {
  const session = await Auth.currentSession();
  const idToken = session.getIdToken().getJwtToken();
  return idToken
}

/**
 * APIリクエスト用
 */
export const postRequest = async (apiName, path, params) => {
  const token = await getAuthToken(); // トークン取得
  const myInit = {
    headers: {
      Authorization: `Bearer ${token}`
    },
    body: { Keys: params },
  };
  return API.post(apiName, path, myInit);
};
/**
 * APIリクエスト用 Keysが無い場合
 */
export const postRequestNoneKey = async (apiName, path, params) => {
  const token = await getAuthToken(); // トークン取得
  const myInit = {
    headers: {
      Authorization: `Bearer ${token}`
    },
    body: params
  };
  return API.post(apiName, path, myInit);
}
/**
 * 日付のフォーマット変更
 */
export const changeDateFormat = (dateTime) => {
  if (!dateTime) return;
  const dateTimeArray = dateTime.split("_");
  let yyyyMMdd = dateTimeArray[0];
  yyyyMMdd = `${yyyyMMdd.slice(0, 4)}-${yyyyMMdd.slice(
    4,
    6
  )}-${yyyyMMdd.slice(6, 8)}`;
  return `${yyyyMMdd}`;
};
/**
 * AOIの名前からAOIのIDに変換
 */
export const getAoiIdFromAoiName = (aoiName, aoisData) => {
  const targetAoi = aoisData.filter(aoiData => aoiData.properties.aoiName === aoiName)[0];
  return targetAoi ? targetAoi.id : null;
}
/**
 * AOIのIDからAOIの名前に変換
 */
export const getAoiNameFromAoiId = (aoId, aoisData) => {
  const targetAoi =  aoisData.filter(aoiData => aoiData.id === aoId)[0];
  return targetAoi ? targetAoi.properties.aoiName : null;
}

/**
 * 斜面変動ランクの数値を文字列に変換
 */
export const getAoiRankName = (rankDataNum) => {
  let rankNameList = {};
  rankDataNum.forEach(value => {
    let rankText =  '';
    switch (value.num){
      case 1:
        rankText = '変動A’’(警戒変動)';
      break;
      case 2:
        rankText = '変動A’(注意変動)';
      break;
      case 3:
        rankText = '変動A(確定変動)';
      break;
      case 4:
        rankText = '変動B(準確定変動)';
      break;
      case 5:
        rankText = '変動C(潜在変動)以下';
      break;
      case 'no_data':
        rankText = '解析データなし';
      break;
    }
    rankNameList[value.name] = rankText;
  })
  return rankNameList;
}

// 日付をYYMMDDで出力する
export const getDateYYMMDD = (date) => {
  var dt = new Date(date);
  var y = dt.getFullYear();
  var m = ('00' + (dt.getMonth() + 1)).slice(-2);
  var d = ('00' + dt.getDate()).slice(-2);
  var result = y + '/' + m + '/' + d;
  return result;
};

// 日付の0を削除する処理
export const getDate0remove = (date) => {
  const [year, month, day] = date.split('/');
  // 先頭の0を削除
  const formattedMonth = month.startsWith('0') ? month.slice(1) : month;
  const formattedDay = day.startsWith('0') ? day.slice(1) : day;

  // 新しいフォーマットで日付を結合
  return `${year}/${formattedMonth}/${formattedDay}`;
}

// フィルタリング中の解析点の数を計算
export const AnalysisPointDeleteRate = (analysisFilterCalcRate) => {
  // マップ画面に解析点が1つも存在しない場合
  if (analysisFilterCalcRate.allPointNum === 0){
    return "..."
  }
  const deleteRate = analysisFilterCalcRate.FilterPointNum / analysisFilterCalcRate.allPointNum * 100;
  return deleteRate.toFixed(2) + "%"
}

// 追加レイヤーのgeojsonの塗りの色を算出
export const hslToHex = (hue) => {
  const saturation = 100;  // 彩度 (固定値: 100%)
  const lightness = 50;     // 明度 (固定値: 50%)

  const s = saturation / 100;
  const l = lightness / 100;

  const c = (1 - Math.abs(2 * l - 1)) * s;
  const x = c * (1 - Math.abs((hue / 60) % 2 - 1));
  const m = l - c / 2;

  let r = 0, g = 0, b = 0;

  if (0 <= hue && hue < 60) { r = c; g = x; b = 0; }
  else if (60 <= hue && hue < 120) { r = x; g = c; b = 0; }
  else if (120 <= hue && hue < 180) { r = 0; g = c; b = x; }
  else if (180 <= hue && hue < 240) { r = 0; g = x; b = c; }
  else if (240 <= hue && hue < 300) { r = x; g = 0; b = c; }
  else if (300 <= hue && hue < 360) { r = c; g = 0; b = x; }

  r = Math.round((r + m) * 255);
  g = Math.round((g + m) * 255);
  b = Math.round((b + m) * 255);

  return `#${((1 << 24) | (r << 16) | (g << 8) | b).toString(16).slice(1).toUpperCase()}`;
}